module.exports = __webpack_public_path__ + "assets/images/CODPayment.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CODPayment.png
// module id = 1349
// module chunks = 1